import React, { useState, useCallback, useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import ConfigExplorerColumn from '../feed_configs/ConfigExplorerColumn';
import ConfigEditorColumn from '../feed_configs/ConfigEditorColumn';
import { useDeploy } from '../contexts/DeployContext';
import { useGlobal } from '../contexts/GlobalContext';

const FeedConfigsService = () => {
  const { setCurrentContext, mergeCurrentContext } = useGlobal();
  const { deployApi } = useDeploy();
  const [editingConfig, setEditingConfig] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSaved = useCallback(() => {
    setRefreshKey((k) => k + 1);
    setEditingConfig(null);
  }, []);

  const handleClearEdit = useCallback(() => {
    setEditingConfig(null);
  }, []);

  const handleDeleteConfig = useCallback(async (config) => {
    if (!config?.config_id) return;
    try {
      await deployApi.deleteFeedConfig(config.config_id);
      setRefreshKey((k) => k + 1);
      setEditingConfig(null);
    } catch (err) {
      console.error('Failed to delete Feed Config:', err);
    }
  }, [deployApi]);

  useEffect(() => {
    setCurrentContext({
      product: 'deploy',
      page: 'feed-configs',
    });
    return () => setCurrentContext(null);
  }, [setCurrentContext]);

  useEffect(() => {
    mergeCurrentContext({
      editingConfig: editingConfig ? { config_id: editingConfig.config_id } : undefined,
    });
  }, [editingConfig, mergeCurrentContext]);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ width: '100%', alignItems: 'flex-start', minHeight: 'calc(100vh - 120px)' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ConfigExplorerColumn
            refreshKey={refreshKey}
            onEditConfig={setEditingConfig}
            onDeleteConfig={handleDeleteConfig}
            onDuplicateConfig={setEditingConfig}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ConfigEditorColumn
            editingConfig={editingConfig}
            onSaved={handleSaved}
            onClearEdit={handleClearEdit}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default FeedConfigsService;
